<template>
  <div v-bind:class="[{ selected: selected }]">
    <div
      class="btn-payment"
      v-bind:class="{ select: selected, 'has-error': hasError }"
      @click="selected ? false : $emit('click')"
    >
      <div class="btn-payment-content">
        <img
          width="40px"
          height="40px"
          class="w-full fit-contain"
          :src="image"
        />

        <div class="btn-payment-title">
          {{ name }}
        </div>

        <div v-if="label" class="btn-payment-desc">
          {{ label }}
        </div>
      </div>

      <button
        v-if="paymentPromotionTitle"
        type="button"
        :class="[
          'btn-payment-promotion',
          { 'has-html': paymentPromotionHtml },
        ]"
        @click.stop="onShowPaymentPromotion"
      >
        <span>{{ paymentPromotionTitle }}</span>
        <v-icon v-if="paymentPromotionHtml" size="14"
          >mdi-chevron-right</v-icon
        >
      </button>
    </div>
  </div>
</template>

<script>
import colorBnn from '@/config/color'

export default {
  name: 'CheckoutPaymentMethodItem',
  props: {
    name: String,
    label: String,
    image: String,
    selected: Boolean,
    hasError: Boolean,
    paymentPromotionTitle: String,
    paymentPromotionHtml: String,
    items: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      colorBnn,
      installmentPlan: this.items ? this.items[0] : null,
    }
  },
  methods: {
    handleChange() {
      this.$emit('updateInstallmentPlan', this.installmentPlan)
    },

    onShowPaymentPromotion() {
      if (!this.paymentPromotionTitle || !this.paymentPromotionHtml)
        return

      this.$emit('show', {
        title: this.paymentPromotionTitle,
        html: this.paymentPromotionHtml,
      })
    },
  },
  watch: {
    selected(newVal) {
      if (newVal && this.items?.length > 0) {
        this.installmentPlan = this.items[0] ?? null
        this.handleChange()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.btn-payment
    width 100%
    background white
    cursor pointer
    box-shadow: 0 0 0 1px $color-bnn-gray-light;
    border-radius: 8px;
    height: auto;
    transition: 0.2s ease-in-out;
    text-align: center;
    height: 100%
    display: flex
    flex-direction: column
    justify-content: space-between
    @media (hover: hover) and (pointer: fine)
        &:hover
          border-color: transparent;
          box-shadow: 0 0 0 1px $color-bnn-border;
          transition: 0.2s ease-in-out;
    .text-btn-payment
        font-size 1rem
    @media medium
        .text-btn-payment
            font-size 1.2rem
    @media small
        .text-btn-payment
            font-size 0.8rem
.btn-payment.select
    box-shadow: 0 0 0 1px $color-bnn;
    border-color: transparent;
.btn-payment.has-error
     border-color: red;

.btn-payment-title
    font-weight: 500
.btn-payment-desc
    font-size: 12px
.btn-payment-content
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
	gap: 8px
	padding: 12px 12px 0

.btn-payment-promotion
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 2px
    padding: 12px

    max-width: 100%

    margin-top: 4px
    font-size: 12px
    font-weight: 500
    line-height: 1.4
    text-align: center
    color: #008900
    pointer-events: fill
    border-top: 1px solid $color-bnn-gray-light

    &.has-html&:focus > span
        outline: none
        text-decoration: underline

    @media (hover: hover) and (pointer: fine)
        &.has-html&:hover > span
            text-decoration: underline

    > span
        min-width: 0
        overflow: hidden
        white-space: nowrap
        text-overflow: ellipsis

    .v-icon
        color: inherit
        flex-shrink: 0
</style>
